import { toast } from "react-toastify";
import * as React from 'react';
import './App.css'
import { Routes, Route } from "react-router-dom"
import config from "./config.json";
import { useRef, useMemo, useContext, useEffect, useState } from 'react';
import Layout1 from './components/Layout1';
import Layout2 from './components/Layout2';
import Layout3 from './components/Layout3';
import Layout4 from './components/Layout4';
import Main from './components/Main';
import Login from './components/Login';
import Register from './components/Register';
import Forgot from './components/Forgot';
import Profile from './components/Profile';
import QrCode from './components/QrCode';
import QrCodePet from './components/QrCodePet';
import QrCodeEdit from './components/QrCodeEdit';
import QrCodeNew from './components/QrCodeNew';
import NotFound from './components/NotFound'; 
import Exhibition from './components/Exhibition'; 
//import QrCodeGet from './components/QrCodeGet'; 
import { ToastContainer } from "react-toastify";
import { UserProvider } from "./store/userContext";
 

export default () => {



  return (
    <>
      <ToastContainer
        bodyClassName={() => "myToastClass"}
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        rtl={true}
      />
      <UserProvider value={
        {

        }
      }>


        <Routes>
          <Route element={<Layout1 />} >
            <Route path='/login' element={<Login />} />
            <Route path='/Forgot' element={<Forgot />} />
          </Route>
          <Route element={<Layout4   />} >
            <Route path='/Register' element={<Register />} />
            <Route path='/Register/:code' element={<Register />} />
            <Route path='/account/Register2' element={<Register />} />
            <Route path='/QrCode/Read' element={<QrCode />} />
            <Route path='/QrCodePet' element={<QrCodePet />} />
            <Route path='/edit/:id' element={<QrCodeEdit />} />
            <Route path='/New' element={<QrCodeNew />} />                 
          </Route>
          <Route element={<Layout2 />} >
            <Route path="/Main" element={<Main />} />
            <Route path="/profile" element={<Profile />} />
            {/*<Route path="/QrCodeGet" element={<QrCodeGet />} />*/}
            <Route path="/" element={<Main />} />
          </Route> 
           <Route element={<Layout3 />} >
            <Route path='/Exhibition' element={<Exhibition />} />  
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>

      </UserProvider >
    </>
  );
}